class RecentlyViewedWriter extends window.BAO.CustomElement() {
  setupListeners () {
    this.storageKey = 'baoRecentlyViewed'
    this.maximumStoredProducts = 20
    this.productHandle = this.dataset.productHandle

    if (!this.productHandle) return

    this.writeProduct()
  }

  writeProduct () {
    const recentlyViewedProducts = this.getRecentlyViewedProducts()

    const filteredProducts = recentlyViewedProducts.filter(
      (handle) => handle !== this.productHandle,
    )

    filteredProducts.unshift(this.productHandle)

    const updatedProducts = filteredProducts.slice(
      0,
      this.maximumStoredProducts,
    )

    try {
      window.localStorage.setItem(
        this.storageKey,
        JSON.stringify(updatedProducts),
      )
    } catch (error) {
      // localStorage may be unavailable.
    }
  }

  getRecentlyViewedProducts () {
    try {
      const storedProducts = window.localStorage.getItem(
        this.storageKey,
      )

      if (!storedProducts) return []

      const parsedProducts = JSON.parse(storedProducts)

      if (!Array.isArray(parsedProducts)) return []

      return parsedProducts
    } catch (error) {
      return []
    }
  }
}

class RecentlyViewedProducts extends window.BAO.CustomElement() {
  setupListeners () {
    this.storageKey = 'baoRecentlyViewed'

    this.productList = this.querySelector(
      '[data-recently-viewed-product-list]',
    )

    this.limit = Number(this.dataset.limit) || 6
    this.currentProductHandle =
      this.dataset.currentProductHandle || ''

    if (!this.productList) return

    this.loadProducts()
  }

  getRecentlyViewedProducts () {
    try {
      const storedProducts = window.localStorage.getItem(
        this.storageKey,
      )

      if (!storedProducts) return []

      const parsedProducts = JSON.parse(storedProducts)

      if (!Array.isArray(parsedProducts)) return []

      return parsedProducts
        .filter((handle) => {
          if (typeof handle !== 'string') return false
          if (handle === '') return false

          if (
            this.currentProductHandle &&
            handle === this.currentProductHandle
          ) {
            return false
          }

          return true
        })
        .slice(0, this.limit)
    } catch (error) {
      return []
    }
  }

  async loadProducts () {
    const productHandles = this.getRecentlyViewedProducts()

    if (productHandles.length === 0) {
      this.handleProductsLoaded()

      return
    }

    const productRequests = productHandles.map((handle) => {
      return this.fetchProduct(handle)
    })

    const products = await Promise.all(productRequests)

    products.forEach((productMarkup) => {
      if (!productMarkup) return

      this.insertProduct(productMarkup)
    })

    this.handleProductsLoaded()
  }

  async fetchProduct (handle) {
    const slider = this.closest('multi-column-slider')
    const inCarousel = slider?.dataset.enableSlider === 'true'
    const view = inCarousel ? 'recently-viewed-hover' : 'recently-viewed'

    try {
      const response = await window.fetch(
        `/products/${encodeURIComponent(handle)}?view=${view}`,
      )

      if (!response.ok) return null

      return await response.text()
    } catch (error) {
      return null
    }
  }

  insertProduct (productMarkup) {
    const template = document.createElement('template')

    template.innerHTML = productMarkup.trim()

    const product = template.content.querySelector(
      '[data-recently-viewed-product-card]',
    )

    if (!product) return

    const slider = this.closest('multi-column-slider')
    const inCarousel = slider?.dataset.enableSlider === 'true'
    const slide = document.createElement('li')

    slide.className = inCarousel
      ? 'sec-MultiColumnSlider_Item keen-slider__slide'
      : 'sec-MultiColumnSlider_Item'

    slide.dataset.recentlyViewedProduct = ''

    slide.appendChild(product)

    this.productList.appendChild(slide)
  }

  handleProductsLoaded () {
    const slider = this.closest('multi-column-slider')

    if (!slider) return

    slider.dispatchEvent(
      new CustomEvent('recently-viewed:loaded'),
    )
  }
}

if (!customElements.get('recently-viewed-writer')) {
  customElements.define(
    'recently-viewed-writer',
    RecentlyViewedWriter,
  )
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define(
    'recently-viewed-products',
    RecentlyViewedProducts,
  )
}
